import type { ResourceConfig } from "../types";

export const mediaConfig = {
  displayName: "素材",
  category: "media",
  permissions: {
    "read:all": {
      label: "查看所有素材",
      description: "可以查看系统中所有素材",
    },
    "write:all": {
      label: "编辑所有素材",
      description: "可以编辑系统中所有素材",
    },
    "read:assigned": {
      label: "查看自己负责的素材",
      description: "只能查看与自己相关的素材",
    },
    "write:assigned": {
      label: "编辑自己负责的素材",
      description: "只能编辑与自己相关的素材",
    },
  },
  scopeStrategy: "byEnrollmentStaff",
  navigation: null,
} satisfies ResourceConfig;
